import { type DefaultQueryError, httpClient } from '@ahm/api-wrappers-core';
import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import type { DefaultOpsTechResponse } from '../types';
import type { MyReward } from './types';
import type { GetRewardParams } from './use-get-reward';
import apiRoutes from '@/lib/api-routes';

export type GetMyRewardParams = Pick<
  GetRewardParams,
  'category_id' | 'type'
> & { is_used?: boolean };

export const getMyRewardFn = async (params: GetMyRewardParams) => {
  const response = await httpClient.get<DefaultOpsTechResponse<MyReward[]>>(
    apiRoutes.rewards.myReward,
    {
      params,
    }
  );
  return response.data.data;
};

export const useGetMyReward = (
  params: GetMyRewardParams,
  opts?: UseQueryOptions<MyReward[], DefaultQueryError>
) =>
  useQuery<MyReward[], DefaultQueryError>({
    queryKey: [apiRoutes.rewards.myReward, params],
    queryFn: () => getMyRewardFn(params),
    ...opts,
  });
